import { GuestHomeScreenMobile } from '@/modules/guest';

/** Mobile guest home — `/guest-home` (temporary entry point from login's "Continue as Guest"). */
export default function GuestHomeRoute() {
  return <GuestHomeScreenMobile />;
}
